import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicMessageFilled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M3 12a1.5 1.5 0 01-1.5-1.5v-7C1.5 2.67 2.17 2 3 2h10c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-1v2.3a.5.5 0 01-.85.35L8.5 12H3zm2-5.75h6a.75.75 0 100-1.5H5a.75.75 0 000 1.5zm0 3h4a.75.75 0 000-1.5H5a.75.75 0 000 1.5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicMessageFilled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicMessageFilled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicMessageFilled svgRef={ref} {...props} />
));
export default ForwardRef;
